var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongZhongmingming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.581 4.8H2.864a.5.5 0 00-.5.5v5.4a.5.5 0 00.5.5H5.58m4.8-6.4h2.682a.5.5 0 01.5.5v5.4a.5.5 0 01-.5.5h-2.682",
    stroke: "#37435C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.382 2.4h3.2",
    stroke: "#37435C",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.382 13.6h3.2",
    stroke: "#37435C",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.982 2.4v11.2",
    stroke: "#37435C",
    strokeLinecap: "square"
  })));
}
export default __webpack_public_path__ + "static/tongyong_zhongmingming.731ed06f.svg";
export { SvgTongyongZhongmingming as ReactComponent };